module.exports = __webpack_public_path__ + "static/media/PhoneIcon.fab8430d.svg";